import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AppUrls } from '../../app-urls';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../utilities';

@Component({
  selector: 'app-regulations-window',
  templateUrl: './regulations-window.component.html',
  styleUrls: ['./regulations-window.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegulationsWindowComponent {
  @Input() visible: boolean;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() continue: EventEmitter<any> = new EventEmitter();

  public pdfUrl: SafeUrl;
  public downLoadPdfUrl: SafeUrl;
  public isIe = Utilities.isIe();

  constructor(private _sanitizer: DomSanitizer, private _configurationService: ConfigurationService) {
    const baseUrl = this._configurationService.configuration.links.fcsBaseUrl;
    this.pdfUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
      baseUrl + AppUrls.regulationsUrls.regulationsDocumentUrl
    );
    this.downLoadPdfUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
      baseUrl + AppUrls.regulationsUrls.downLoadRegulationsDocumentUrl
    );
  }

  public close(event: boolean): void {
    this.visible = !event;
    this.visibleChange.emit(!event);
  }
}
